import { PrismaSubscriptionProductDto } from 'app/API';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  plan: PrismaSubscriptionProductDto;
  className?: string;
};

export const CanceledCard = ({ plan, className = '' }: TProps) => {
  const planName = plan?.name.replace('AutoScriptOne ', '');

  return (
    <Wrapper className={className}>
      <div className="content">
        <h2 className="as-one">Subscription</h2>
        <p className="description">
          {planName} plan has been canceled and will expire at the end of the billing period.
        </p>
      </div>
    </Wrapper>
  );
};
